export const SecondInMs = 1000;
export const MinuteInMs: number = SecondInMs * 60;
export const HourInMs: number = MinuteInMs * 60;
export const DayInMs: number = HourInMs * 24;

// Not as accurate, because months can, of course, have 29 or 31 days
export const MonthInMs: number = DayInMs * 30;

// Also not accurate as a quarter has between 90 and 92 days.
export const QuarterInMs: number = MonthInMs * 3;

export const YearInMs: number = DayInMs * 365;
